import { put, call } from "redux-saga/effects";
import { Actions } from "../../../constants/actionTypes";
import { getStore } from "../../../../Utils/storeUtils";
import { apiRequest } from "../../../../Utils/axiosApi";
import { Toast } from "../../../../Utils/notifications";
import { API_METHODS, ENDPOINTS } from "../../../endpoint";

export function* fetchAllSites(action) {
  try {
    const result = yield call(apiRequest, {
      method: "GET",
      url: `/siteDetails/getSitesOrg?orgId=${action.data.orgId}`,
    });

    if (result.isApiSuccessful) {
      action?.meta?.onSuccess();
      yield put({
        type: Actions.SET_ALL_SITES,
        data: { ...result.data, isApiSuccessful: true },
      });
    } else {
      action?.meta?.onError();
      yield put({
        type: Actions.SET_ALL_SITES,
        data: { isApiSuccessful: false },
      });
    }
  } catch (err) {
    action?.meta?.onError();
    yield put({
      type: Actions.SET_ALL_SITES,
      data: { isApiSuccessful: false },
    });
    // Toast("Technical error", "Failed to fetch the Sites", "danger");
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiSelectedSite(action) {
  try {
    const result = yield call(apiRequest, {
      method: API_METHODS.GET,
      url: `${ENDPOINTS.SITE_DETAILS}/${action.data.siteId}`,
    });

    if (result.isApiSuccessful === true) {
      yield put({
        type: Actions.SET_SELECTED_SITE_DETAILS,
        data: { ...result.data, isApiSuccessful: true },
      });
      action.meta?.onSuccess(result.data);
    } else {
      // Toast("Technical error", "Failed to fetch the Site", "danger");
      yield put({
        type: Actions.SET_SELECTED_SITE_DETAILS,
        data: {
          isApiSuccessful: false,
          errorMessage: result?.response?.data?.errorMessage,
        },
      });
      action.meta?.onError();
    }
  } catch (err) {
    yield put({
      type: Actions.SET_SELECTED_SITE_DETAILS,
      data: { isApiSuccessful: false, errorMessage: "error" },
    });
    Toast("Technical error", "Failed to fetch the Sites", "danger");
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiRemoveSite(action) {
  try {
    const result = yield call(apiRequest, {
      method: "DELETE",
      url: `/siteDetails/delete/${action.data.siteId}`,
    });

    const statusCode = result.status || result.response?.status;

    if (statusCode >= 200 && statusCode < 300) {
      return { isApiSuccessful: true, data: result };
    } else if (statusCode === 504) {
      return { isApiSuccessful: true, data: result };
      // return {
      //   isApiSuccessful: true,
      //   data: { ...result, suppressErrorPopup: true },
      // };
    } else if (statusCode === 406) {
      return { isApiSuccessful: false, data: result };
    } else {
      return { isApiSuccessful: false, data: result };
    }
  } catch (err) {
    if (err?.response?.status === 504 || err?.code === "ECONNABORTED") {
      return {
        isApiSuccessful: true,
        data: { ...err, suppressErrorPopup: true },
      };
    }
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiGraphDetails(action) {
  try {
    const result = yield call(apiRequest, {
      url: `${ENDPOINTS.SITE_DETAILS}/getGraphData?siteId=${action.data.siteId}&timeInterval=${action.data.timeInterval}`,
      method: API_METHODS.GET,
    });
    if (result.isApiSuccessful) {
      getStore().dispatch({
        type: Actions.SET_GRAPH_DETAILS,
        data: result,
      });
      return result;
    } else {
      action.meta?.onError?.();
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta?.onError?.();
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiAlertDetail(action) {
  try {
    const result = yield call(apiRequest, {
      url: `${ENDPOINTS.AWS}/getAlerts?siteId=${action.data.siteId}&stagingDomainName=${action.data.stagingDomainName}`,
      method: API_METHODS.GET,
    });
    if (result.isApiSuccessful) {
      getStore().dispatch({
        type: Actions.SET_ALERTS_DETAILS,
        data: result.data,
      });

      return result;
    } else {
      action.meta.onError();
      Toast(
        "Technical ",
        result?.data?.errorMessage || "Please try again later",
        "danger",
      );
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta.onError();
    // Toast("Technical Iss", "Please try again later", "danger");
  }
}

export function* apiIsValidSiteName(siteName, isDedicated) {
  try {
    const result = yield call(apiRequest, {
      url: `/siteDetails/isValidSiteName?siteName=${siteName}&isDedicated=${isDedicated}`,
      method: "GET",
    });
    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiLbName(action) {
  try {
    const result = yield call(apiRequest, {
      method: "GET",
      url: `/AWS/getLbDetails?siteName=${action.data.siteName}`,
    });

    const payload = {
      siteId: action.data.siteId,
      lbArn: result.isApiSuccessful ? result.data : false,
    };

    yield put({
      type: Actions.SET_SITES_LB_ARN,
      data: payload,
    });

    if (process.env.REACT_APP_TEMP_DOMAIN === "roconpaas.io") {
      // console.log("After API Proimse of All Sites", getStore().getState());
    } else {
      console.log("After API Proimse of All Sites", getStore().getState());
    }

    return result.isApiSuccessful
      ? result
      : { isApiSuccessful: false, data: null };
  } catch (err) {
    console.log(err);
    return { isApiSuccessful: false, data: null };
  }
}

export function* apiGetSiteImages(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/siteDetails/imageUploadSite`,
      method: "POST",
      data: action.data,
    });
    if (result.isApiSuccessful) {
      getStore().dispatch({
        type: Actions.SET_SITE_IMAGE,
        data: result,
      });
      // Toast("Success!!", "Site Image Uploaded successfully!", "success");
      return result;
    } else {
      // Toast("Technical Error", "Please try again later", "danger");
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiDelImage(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/siteDetails/removeSiteImage?siteName=${action.data.siteName}`,
      method: "DELETE",
    });
    if (result.isApiSuccessful) {
      // Toast("Success!!", "Site Image Deleted successfully!", "success");
      return result;
    } else {
      // Toast("Technical Error", "Please try again later", "danger");
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiWordpressVersionUpdate(action) {
  let result;
  try {
    result = yield call(apiRequest, {
      url: `/siteDetails/${action.data.siteId}/wpversion/upgrade/${action.data.version}/${action.data.stagingDomainName}`,
      method: "POST",
    });
  } catch (err) {
    action.meta?.onError?.();
    return { isApiSuccessful: false, data: err };
  }
  if (result?.isApiSuccessful) {
    action.meta?.onSuccess?.(result.data);
    return result;
  }
  // the API explains why (already on that version, backup in progress, ...) in errorMessage
  action.meta?.onError?.(result?.response?.data?.errorMessage);
  return { isApiSuccessful: false, data: null };
}

export function* apiSiteOverview(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/siteDetails/siteOverview?orgId=${action.data.orgId}`,
      method: "GET",
    });
    if (result.isApiSuccessful) {
      getStore().dispatch({
        type: Actions.SET_SITE_OVERVIEW,
        data: result,
      });
      action.meta.onSuccess(result.data);
      return result;
    } else {
      action.meta.onError(result.data);
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiTopSites(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/siteDetails/topPerformSites?orgId=${action.data.orgId}`,
      method: "GET",
    });
    if (result.isApiSuccessful) {
      getStore().dispatch({
        type: Actions.SET_TOP_SITES,
        data: result,
      });
      action.meta.onSuccess(result.data);
      return result;
    } else {
      action.meta.onError(result.data);
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiSitesList(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/siteDetails/siteDetailsList?orgId=${action.data.orgId}`,
      method: "GET",
    });
    if (result.isApiSuccessful) {
      getStore().dispatch({
        type: Actions.SET_SITES_LIST,
        data: result,
      });
      action.meta.onSuccess(result.data);
      return result;
    } else {
      action.meta.onError(result.data);
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiCreateStagingEnvironment(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/siteDetails/create/stagingDomain`,
      method: "POST",
      data: action.data,
    });
    if (result.status >= 200 && result.status < 300) {
      return { isApiSuccessful: true, data: result };
    } else {
      return { isApiSuccessful: false, data: result };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiDeleteStagingEnvironment(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/siteDetails/delete/stagingDomain/${action.data.stagingDomainName}`,
      method: "DELETE",
    });
    if (result.isApiSuccessful) {
      return result;
    } else {
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiStagingToggle(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/Addon/stagingToggle?orgId=${action.data.orgId}&siteId=${action.data.siteId}&toggle=${action.data.toggle}`,
      method: "GET",
    });
    if (result.isApiSuccessful) {
      getStore().dispatch({
        type: Actions.SET_TOGGLE_STAGING,
        data: result,
      });
      action.meta.onSuccess(result.data);
      return result;
    } else {
      action.meta.onError(result.data);
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* submitMigrateDetails(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/siteDetails/submitMigrateDetails`,
      method: "POST",
      data: action.data,
    });
    if (result.status >= 200 && result.status < 300) {
      return { isApiSuccessful: true, data: result };
    } else {
      return { isApiSuccessful: false, data: result };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* isMigrationProgress(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/siteDetails/getMigrationProgress?siteId=${action.data.siteId}`,
      method: "GET",
    });
    if (result.isApiSuccessful) {
      getStore().dispatch({
        type: Actions.SET_MIGRATION_PROGRESS,
        data: result,
      });
      action.meta.onSuccess(result.data);
      return result;
    } else {
      action.meta.onError(result.data);
      return { isApiSuccessful: false, data: result.data };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiStagingDomainList(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/siteDetails/stagingDomList?siteId=${action.data.siteId}&toggle=${action.data.toggle}`,
      method: "GET",
    });

    if (result.isApiSuccessful) {
      getStore().dispatch({
        type: Actions.SET_STAGING_DOMAIN_LIST,
        data: result.data,
      });
      action.meta.onSuccess(result.data);
      return result;
    } else {
      action.meta.onError(result.data);
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* executeCommand(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/siteDetails/command?command=${action.data.command}&siteId=${action.data.siteId}`,
      method: "POST",
      data: action.data,
    });
    if (result.isApiSuccessful) {
      action.meta.onSuccess(result.data);
      return result;
    } else {
      action.meta.onError(result.data);
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiStagingRemainTs(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/Addon/Timestamps?orgId=${action.data.orgId}&siteId=${action.data.siteId}`,
      method: "GET",
    });

    if (result.isApiSuccessful) {
      getStore().dispatch({
        type: Actions.SET_STAGING_TIMESTAMP,
        data: result.data,
      });
      action.meta.onSuccess(result.data);
      return result;
    } else {
      action.meta.onError(result.data);
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* autoLogin(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/siteDetails/autoLogin?portal=${action.data.portal}&stagingDomainId=${action.data.stagingDomainId}`,
      method: "GET",
    });

    if (result.isApiSuccessful) {
      action.meta.onSuccess(result.data);
      return result;
    } else {
      action.meta.onError(result.data);
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiFetchPlanOvergauge(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/cashfree/fetchPlanOverguagePaymentLink?orgId=${action.data.orgId}`,
      method: "GET",
    });

    if (result.isApiSuccessful) {
      yield put({
        type: Actions.SET_PLAN_OVERGAUGE,
        data: { ...result.data, isApiSuccessful: true },
      });
      action.meta.onSuccess(result.data);
      return result;
    } else {
      yield put({
        type: Actions.SET_PLAN_OVERGAUGE,
        data: { isApiSuccessful: false },
      });
      action.meta.onError(result.data);
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiDownloadInstanceKey(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/siteDetails/key/${action.data.instanceName}`,
      method: "GET",
    });

    if (result.isApiSuccessful) {
      action.meta.onSuccess(result.data);
      return result;
    } else {
      action.meta?.onError?.(result.data);
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta?.onError?.(err);
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiGetLightSailPassword(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/siteDetails/getPassword?instanceName=${action.data.instanceName}`,
      method: "GET",
    });

    if (result.isApiSuccessful) {
      action.meta?.onSuccess?.(result.data);
      return result;
    } else {
      action.meta?.onError?.(result.data);
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta?.onError?.(err);
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiInstallDomain(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/siteDetails/makeDomainPrimary`,
      method: "POST",
      data: action.data,
    });

    if (result.isApiSuccessful) {
      action.meta?.onSuccess?.(result.data);
      return result;
    } else {
      action.meta?.onError?.(result?.response?.data?.errorMessage);
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta?.onError?.(err?.response?.data?.errorMessage);
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiDedicatedRestore(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/siteDetails/restore/${action.data.backupId}/${action.data.siteName}`,
      method: "POST",
    });
    if (result.isApiSuccessful) {
      action.meta?.onSuccess?.(result.data);
      return result;
    } else {
      action.meta?.onError?.(result.data);
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta?.onError?.(err);
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiDedicatedOnDemandBackup(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/siteDetails/backup/${action.data.siteName}/${action.data.isOnDemand}/${action.data.tag}`,
      method: "POST",
      data: action.data,
    });
    if (result.isApiSuccessful) {
      action.meta?.onSuccess?.(result.data);
      return result;
    } else {
      action.meta?.onError?.(result.data);
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta?.onError?.(err);
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiGetDedicatedStorage(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/siteDetails/fetchStorage/${action.data.siteName}`,
      method: "GET",
    });

    if (result.isApiSuccessful) {
      yield put({
        type: Actions.SET_DEDICATED_STORAGE,
        data: { ...result.data, isApiSuccessful: true },
      });
    } else {
      action.meta?.onError?.(result.data);
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta?.onError?.(err);
    return { isApiSuccessful: false, data: err };
  }
}

export function* apidedicatedPhpCreds(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/siteDetails/fetchDbCreds?instanceName=${action.data.siteName}`,
      method: "GET",
    });

    if (result.isApiSuccessful) {
      yield put({
        type: Actions.SET_DEDICATED_PHP_CREDS,
        data: { ...result.data },
      });
      action.meta.onSuccess(result.data);
      return result;
    } else {
      action.meta?.onError?.(result.data);
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    action.meta?.onError?.(err);
    return { isApiSuccessful: false, data: err };
  }
}
